<template>
  <div id="home" ref="home">
    <head-com></head-com>
    <div class="banner">
      <div class="banner-center">
        <div class="banner-img">
          <el-carousel :interval="5000" arrow="hover" :height="bannerHeight">
            <el-carousel-item v-for="item in banner" :key="item.id">
              <img :src="URL+item.pic_url"/>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="denglu r">
          <img class="touxiang" @click="HeadPortrait" v-if="userInfo.userHeaderImg" :src="URL+userInfo.userHeaderImg" />
          <img class="touxiang" @click="HeadPortrait" v-else src="../../assets/img/default-head.png" />
          <h3 class="l" v-if="userInfo.userName!=null"><span class="user-name text1-hidden">Hi, {{userInfo.userName}}</span></h3>
          <h3 class="l" v-else>Hi,欢迎来到{{$constant.mainTitle}}</h3>
          <div class="qdl l" v-if="userInfo.userName==null">
            <span class="qingdenglu both" @click="logIn">请登录</span>
            <router-link to="agreement" class="kaidian both">我要开店</router-link>
          </div>
          <div class="qdl l" v-else>
            <router-link class="qingdenglu both" to='myOrder?id=1'>查看订单</router-link>
            <router-link to="personalData" class="kaidian both">查看资料</router-link>
          </div>
          <h4 class="l">公告</h4>
          <div class="seamless-warp wufeng l">
            <ul class="item">
              <li @click="Announcement(item.id)" v-for="(item,index) in items" :key="index">{{item.title}}</li>
            </ul>
          </div>
          <h4 class="l rukou">快捷入口</h4>
          <ul class="ul l">
            <li>
              <!-- <router-link to="ecentBrowse" > -->
              <a href="javascript:;" @click="toLink('ecentBrowse')">
                <i class="el-icon-view"></i><br/> 我的浏览
              </a>
  
              <!-- </router-link> -->
            </li>
            <li>
              <a href="javascript:;" @click="toLink('collect')">
                <img src="../../assets/img/heart.jpg" /> 我的收藏
              </a>
              <!-- <router-link to="collect"> -->
  
              <!-- </router-link> -->
            </li>
            <li>
              <a href="javascript:;" @click="toLink('myOrder',0)">
                <i class="el-icon-date"></i>
                <br />我的订单
              </a>
              <router-link to="myOrder?id=1">
  
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="paimai">
        <img class="l" src='../../assets/img/paimai01.jpg' />
        <img class="l" src='../../assets/img/paimai02.jpg' />
        <img class="l" src='../../assets/img/paimai03.jpg' />
        <img class="l" src='../../assets/img/paimai04.jpg' />
        <img class="l" src='../../assets/img/paimai05.jpg' />
      </div>
      <div class="dianpu">
        <div class="left l"><img class="l" src="../../assets/img/dianpu.jpg" /></div>
        <ul class="r">
          <li class="l right" v-for="(pinpai,index) in pinpais" :key="index"><img :src="URL+pinpai.store_logo" />
            <div class="click">
              <span @click="$router.push({
                    path: '/storehome',
                    query: {
                      id:pinpai.id
                    }
                  })">点击进入</span>
            </div>
          </li>
          <li class="another" @click="anotherFun">
            <img :src="huanyipi" />
            <p>换一批</p>
          </li>
        </ul>
      </div>
      <div class="gongyi same" v-for="(item,page) in allFloor" :key="page">
        <h1>{{page+1}}F {{item.floor.class_name}}</h1>
        <ul class="l tabul">
          <li class="l tab " :key="index" v-bind:class="{active:isactive[page] == index}" @mousemove="tab(index,page)" v-for="(gongyis,index) in gongyi">{{gongyis}}</li>
        </ul>
        <div class="huaping l">
          <img class="l classImg" v-lazy="item.floor.pic_url === '' ? classImg : URL + item.floor.pic_url" />
          <div class="bottom l">
            <ul class="bottomul">
              <li class="l bottomli" @click="entryClass(jingruis)" v-for="(jingruis,index) in item.classTwo" :key="index">{{jingruis.class_name}}</li>
            </ul>
          </div>
        </div>
        <div class="swiper l" @mouseover="stop()" @mouseout="move()">
          <div class="slideshow">
            <el-carousel :interval="5000" arrow="always" :height="imgHeight">
              <el-carousel-item v-for="(img,index) in item.imgArray" :key="index">
                <img v-lazy="item.middle.length===0 ? img.pic_url : URL + img.pic_url"  @click="goto(img)"/>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="showdiv r">
          <ul class="showul l">
            <li :key="index" class="showli l" @click="entryGoods(thing)" v-for="(thing,index) in arr[page]">
              <img class="hp w_h" v-lazy="URL+ thing.pic_url"/>
              <p class="jieshao">{{thing.title}}</p>
              <div class="jiage l">￥
                <span>{{thing.goods_price}}</span>
              </div>
            </li>
          </ul>
        </div>
        <img v-show="(item.button instanceof Array) && item.button.length===0" class="bottomnav" src="../../assets/img/bottom-img.png" />
        <img v-show="!item.button.hasOwnProperty('length')" class="bottomnav" :src="URL+item.button.pic_url" @click="goto(item.button)"/>
      </div>
      <div class="more">
        <span v-show="floorIndex<13" @click="getFloor">加载更多...</span>
      </div>
    </div>
    <foot-com></foot-com>
    <back-top></back-top>
  </div>
</template>

<script>
  import $ from "jquery";
  import hp from '@/assets/img/hp.jpg'
  import avatar from '@/assets/img/gongniu.jpg'
  import avatars from '@/assets/img/hp1.jpg'
  import ns from '@/assets/img/ns.png'
  import chun from '@/assets/img/chun.png'
  import maotai from '@/assets/img/maotai.png'
  import huanyipi from '@/assets/img/huanyipi.jpg'
  import banner1 from '@/assets/img/banner1.jpg'
  import banner2 from '@/assets/img/banner2.jpg'
  import banner3 from '@/assets/img/banner3.jpg'
  export default {
    data() {
      return {
        classImg:hp,
        huanyipi: huanyipi,
        animate: false, //广告滚动处控制
        allFloor: [], //所有楼层的数据
        floorIndex: 1,
        all: false,
        onoff: '',
        img_url: maotai,
        avatar: avatar,
        avatars: avatars,
        display: null,
        showClassify: false,
        marksArr: [], //比对图片索引的变量
        imgArray: [
          {pic_url:ns}, {pic_url:chun}, {pic_url:maotai}],
        isbackcolor: '',
        pinpais: [],
        class_id: 0, //分类ID
        iTem: [],
        condata: [],
        condata2: [],
        condata3: [],
        Array: [],
        gongyi: ['新品推荐', '热卖商品', '疯狂抢购', '猜您喜欢'],
        arr: [],
        items: [],
        isactive: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        isBottom: false,
        bannerArr: [banner1, banner2, banner3],
        banner:[],
        bannerHeight: '407px',
        imgHeight: '488px',
        userInfo: {},
        Go:0
      }
    },
  
    created() {
      this.getFloor();
      // SH-OP-SN
      if (sessionStorage.getItem('userHeaderImg') || sessionStorage.getItem('userName')) {
        this.userInfo = {
          userName: sessionStorage.getItem('userName'),
          userHeaderImg: sessionStorage.getItem('userHeaderImg')
        }
      };
      this.anotherFun();
    },
    mounted() {
      // $('html,body').animate({
      //   scrollTop: '0px'
      // }, 100);
      this.getHome();
      setInterval(this.scroll, 500);
      var that = this;
      $(window).scroll(function() {
        if (!that.$refs.home) return;
        var bot = 700;
        if (that.isBottom == false && (bot + $(window).scrollTop()) >= ($(document).height() - $(window).height())) {
          that.isBottom = true;
          if (that.floorIndex < 13) {
            that.floorIndex++;
            that.getFloor();
          }
        }
      });
    },
  
    methods: {
      //轮播跳转
      goto(img){
        if(img&&img.hasOwnProperty('ad_link')){
           location.href=img.ad_link;
        }
        return
      },
      //头像判断登录跳转
      HeadPortrait(){
        if(this.userInfo.userName!=null){
          this.$router.push({
            name: 'greet'
          })
        }else{
          this.$router.push({
            name: 'passwordLogin'
          })
        }
      },
      toLink(l, n) {
        if (n == 0) {
          window.open(window.location.origin + '/' + l + '?id=1');
        } else {
          console.log('=====' + l)
          window.open(window.location.origin + '/' + l);
        }
      },
      Announcement(id) {
        this.$router.push({
          name: 'notice',
          params: {
            id: id
          }
        })
      },
      anotherFun() {
        this.HTTP(this.$httpConfig.randStore, {}, 'post').then((res) => {
          this.pinpais = res.data.data;
        })
      },
      entryClass(jingruis) {
        // console.log(window.location.origin + '/' + item.pc_url)
        this.Go++;
        window.open(window.location.origin + '/goodsClass?class_id=' + jingruis.id + '&id=' + this.Go+'&class_name='+jingruis.class_name);
      },
      entryGoods(goods) {
        window.open(window.location.origin + '/inroyaldrink?id=' + goods.id);
      },
      // addBuyCar(goods) {
        
      // },
      stop() {
  
      },
      move() {
  
      },
      getHome() {
        //获取公告
        this.HTTP(this.$httpConfig.home, {}, 'post')
          .then((res) => {
            console.log(res);
            this.items = res.data.data.announcement
            this.pinpais = res.data.data.store;
            if(res.data.data.banner.length===0){
              this.banner=this.bannerArr;
            }else{
              this.banner=res.data.data.banner;
            }
          }).catch((e)=>{
            console.log(e)
          })
      },
      /*获取楼层*/
      async getFloor() {
        if (this.floorIndex < 13) {
          await this.HTTP(this.$httpConfig.homefLoor, {
              page: this.floorIndex
            }, 'post')
            .then((res) => {//判断数组是否为空，空则假数据
              if(res.data.data.middle.length === 0){
                res.data.data.imgArray = this.imgArray;
              }else{
                res.data.data.imgArray = res.data.data.middle;
              };
              this.allFloor.push(res.data.data);
              this.marksArr.push(0);
              for (var i = 0; i < this.floorIndex; i++) {
                this.arr[i] = this.allFloor[i].goods_news == [] ? [] : this.allFloor[i].goods_news;
              }
            }).catch((e)=>{
              console.log(e)
            });
            
          
          console.log(this.allFloor[0].goods_news)
          this.isBottom = false;
        }
      },
      scroll() {
        this.animate = true;
        setTimeout(() => {
          this.items.push(this.items[0]);
          this.items.shift();
          this.animate = false;
        }, 500);
      },
      logIn() {
        this.$router.push({
          name: 'passwordLogin'
        })
      },
      tab(index, page) {
        let init = index
        this.isactive[page] = init
        switch (index) {
          case 0:
            {
              this.arr[page] = this.allFloor[page].goods_news;
            }
            break;
          case 1:
            {
              this.arr[page] = this.allFloor[page].hotGoods;
            }
            break;
          case 2:
            {
              this.arr[page] = this.allFloor[page].rushGoods;
            }
            break;
          case 3:
            {
              this.arr[page] = this.allFloor[page].loveGoods;
            }
            break;
          default:
            break;
        }
      }
    },
    components: {},
  
  }
</script>

<style type="text/css" scoped>
  .another {
    float: left;
    text-align: center;
    cursor: pointer;
  }
  
  .another img {
    margin-top: 5px !important;
    width: 20px !important;
    height: 20px !important;
  }
</style>

<style lang="less" scoped>
  .center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;

  }
  
  .l {
    float: left;
  }
  
  .r {
    float: right;
  }
  .w_h {
    width: 140px;
    height: 140px;
  }
  #home {
    position: relative;
    .banner {
      width: 100%;
      height: 407px;
      .banner-center {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: rgba(231, 193, 66, 0.9);
        .banner-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 407px;
          img {
            width: 100%;
            height: 407px;
            z-index: 0;
          }
        }
        .denglu {
          position: absolute;
          top: 0;
          right: 200px;
          width: 204px;
          height: 380px;
          background: #fbfdfc;
          margin-top: 11px;
          z-index: 10;
          .touxiang {
            float: left;
            margin: 10px 62px;
            width: 82px;
            height: 82px;
            border-radius: 50%;
            display: block;
            cursor: pointer;
          }
          h3 {
            text-align: center;
            color: #767676;
            font-size: 12px;
            width: 100%;
            .user-name {
              display: inline-block;
              max-width: 100px;
            }
          }
          .qdl {
            margin: 10px 0 0 27px;
            .both {
              float: left;
              width: 68px;
              text-align: center;
              line-height: 22px;
              height: 22px;
              border: 1px solid #323232;
              font-size: 12px;
            }
            .qingdenglu {
              cursor: pointer;
              color: #a8a8a8;
            }
            .kaidian {
              color: #ac9549;
              border-color: #ac9549;
              margin-left: 10px;
              cursor: pointer;
            }
          }
          .wufeng {
            height: 70px;
            margin: 10px 0 0;
            overflow: hidden;
            .item {
              overflow: hidden;
            }
            li {
              cursor: pointer;
              width: 165px;
              float: left;
              line-height: 25px;
              font-size: 12px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              padding-left: 22px;
            }
          }
          h4 {
            width: 100%;
            height: 24px;
            line-height: 24px;
            margin-top: 22px;
            background: #eeeeee;
            font-size: 12px;
            color: #e2c48e;
            padding-left: 22px;
          }
          .rukou {
            color: #434343;
            margin-top: 11px;
          }
          .ul {
            li {
              float: left;
              width: 68px;
              border-right: 1px solid #eee;
              height: 59px;
              text-align: center;
              img {
                display: block;
                margin: 16px auto 6px;
              }
              i {
                margin-top: 14px;
                margin-bottom: 5px;
                color: #000;
                font-size: 18px;
              }
              a {
                color: #8f8f8f;
                font-size: 12px;
              }
              &:hover a {
                color: red;
              }
            }
            li:last-child {
              border: 0;
            }
          }
        }
      }
    }
    .paimai {
      width: 1200px;
      height: 170px;
      margin-top: 14px;
      display: flex;
      img {
        margin-right: 7px;
      }
      img:last-child {
        margin: 0;
      }
    }
    .dianpu {
      width: 100%;
      height: 307px;
      margin-top: 14px;
      .left {
        width: 435px;
        height: 305px;
      }
      ul {
        margin-left: 9px;
        width: 752px;
        border: 0.5px solid #e8e8e8;
        li {
          width: 150px;
          height: 51px;
          border: 0.5px solid #e8e8e8;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .click {
            display: none;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
            span {
              display: block;
              width: 64px;
              height: 22px;
              background: #eac038;
              line-height: 22px;
              text-align: center;
              border-radius: 15px;
              color: #f4e0bd;
              font-size: 12px;
              margin: 15px auto;
            }
          }
          &:hover .click {
            display: block;
          }
        }
      }
    }
    .same {
      min-height: 550px;
      height: auto;
      margin-top: 15px;
      .same:first-child {
        margin-top: 24px;
      }
      h1 {
        font-size: 20px;
        color: #010101;
        float: left;
        line-height: 35px;
        width: 778px;
        border-bottom: 1px solid #c7c0b6;
      }
      .tabul {
        border-bottom: 1px solid #c5c1b8;
        .tab {
          width: 98px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          border: 1px solid #e6e8e7;
          margin-right: 10px;
          border-bottom: 1px;
          background: #fff;
          cursor: pointer;
        }
        .active {
          border-color: #c5c1b8;
          transform: translateY(1px);
          border-bottom: 0;
          color: #c5c1b8;
        }
        .tab:last-child {
          margin: 0;
        }
      }
      .huaping {
        height: 488px;
        width: 210px;
        .classImg{
          width:210px;
          height:341px;
        }
        .bottom {
          height: 174px;
          width: 100%;
          background: #f7e7b3;
          .bottomul {
            margin-top: 15px;
            .bottomli {
              width: 84px;
              height: 32px;
              background: #fff;
              line-height: 32px;
              text-align: center;
              font-size: 12px;
              margin: 5px 0 0 14px;
              cursor: pointer;
              &:hover {
                color: red;
              }
            }
          }
        }
      }
      .swiper {
        width: 379px;
        height: 488px;
        overflow: hidden;
        position: relative;
        .slideshow {
          width: 379px;
          height: 488px;
          cursor:pointer; 
        }
      }
      .showul {
        width: 611px;
        height: 488px;
        padding-left: 1px;
        border-right: 1px solid #e7e8e3;
        border-bottom: 1px solid #e7e8e3;
        .showli {
          width: 203px;
          height: 244px;
          //border-right: 1px solid #e7e8e3;
          //border-bottom: 1px solid #e7e8e3;
          cursor: pointer;
          img{
            transition: all 300ms linear 300ms;
            -webkit-transition: all 300ms linear 300ms;
          }
          img:hover{
            -webkit-transform: scale(1.1); /*1.1放大值*/
            -moz-transform: scale(1.1); 
            -o-transform: scale(1.1);
            -ms-transform: scale(1.1); 
          }
          .hp {
            margin: 15px 0 0 31px;
          }
          .jieshao {
            height: 36px;
            width: 147px;
            line-height: 18px;
            margin: 9px 0 0 31px;
            font-size: 12px;
            color: #656565;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            &:hover {
              color: red;
            }
          }
          .jiage {
            color: #f64e4d;
            font-size: 13px;
            margin: 12px 0 0 31px;
          }
          .gouwuche {
            width: 30px;
            cursor: pointer;
            height: 30px;
            background: url(../../assets/img/buyCart.png) no-repeat;
            background-size: 100% 100%;
            margin: 4px 28px 0 0;
          }
        }
        .showli:nth-child(3n) {
          border-right: 0;
        }
      }
      .bottomnav {
        width: 100%;
        margin-top: 12px;
        height: 100px;
        cursor:pointer ;
      }
    }
    .more {
      text-align: center;
      height: 48px;
      line-height: 48px;
      color: #f0bf19;
      font-size: 17px;
      font-weight: bold;
    }
  }
</style>
